import useViewModel from './ThermostatSuggestionCard.viewmodel'
import DeviceSuggestionCard from '../DeviceSuggestionCard'
import { CostCategoryPreviewRow } from './ThermostatSuggestionCard.components'
import Separator from '@/app/components/Separator/Separator'
import { Text } from '@/components'

export type Props = Parameters<typeof useViewModel>[0]

const { SettingsSuggestions, SuggestionCard, SuggestionDescription } =
  DeviceSuggestionCard

export default function ThermostatSuggestionCard(props: Props) {
  const viewModel = useViewModel(props)
  const {
    isLoadingOrIdle,
    displayName,
    settingPaths,
    costCategories,
    inactiveTimesCardSubtitleLines,
    gridSupportEnabled,
    gridSupportSettingsSummary,
    precoolEnabled,
    articles,
    settingsWhitelist,
  } = viewModel

  if (isLoadingOrIdle) {
    return null
  }

  return (
    <DeviceSuggestionCard
      iconName="Thermometer"
      title={displayName}
      articles={articles}
    >
      {settingsWhitelist.length > 0 && (
        <SettingsSuggestions>
          {settingsWhitelist.includes('save-money') &&
            costCategories.length > 0 && (
              <SuggestionCard
                iconName="DollarSign"
                title={
                  <Text
                    variant="body3"
                    className="font-bold text-themed-grey-900 mb-2"
                  >
                    Save Money
                  </Text>
                }
                destinationPath={settingPaths.costCategories}
                className="mb-2"
              >
                <div className="flex flex-col gap-1">
                  <CostCategoryPreviewRow
                    type="negative"
                    costCategories={costCategories}
                  />
                  <CostCategoryPreviewRow
                    type="low"
                    costCategories={costCategories}
                  />
                  <CostCategoryPreviewRow
                    type="medium"
                    costCategories={costCategories}
                  />
                  <CostCategoryPreviewRow
                    type="high"
                    costCategories={costCategories}
                  />
                </div>
                <Separator className="my-2 bg-themed-grey-200" />
                <Text
                  variant="body3"
                  className="font-bold text-themed-grey-500"
                >
                  Inactive Times:
                </Text>
                {inactiveTimesCardSubtitleLines.length > 0 ? (
                  inactiveTimesCardSubtitleLines.map((line) => (
                    <SuggestionDescription key={line}>
                      {line}
                    </SuggestionDescription>
                  ))
                ) : (
                  <SuggestionDescription>No times set</SuggestionDescription>
                )}
              </SuggestionCard>
            )}
          {settingsWhitelist.includes('grid-support') && (
            <SuggestionCard
              iconName="Globe"
              title="Grid support"
              destinationPath={settingPaths.gridSupport}
            >
              {gridSupportEnabled && gridSupportSettingsSummary.length > 0 ? (
                <div className="flex flex-col gap-1">
                  {gridSupportSettingsSummary.map((setting) => (
                    <div key={setting.label}>
                      {setting.label && (
                        <Text
                          variant="body3"
                          className="font-bold text-themed-grey-500"
                        >
                          {setting.label}
                        </Text>
                      )}
                      <SuggestionDescription>
                        {setting.description}
                      </SuggestionDescription>
                    </div>
                  ))}
                </div>
              ) : (
                <SuggestionDescription>Disabled</SuggestionDescription>
              )}
            </SuggestionCard>
          )}
          {settingsWhitelist.includes('precool') && (
            <SuggestionCard
              iconName="Wind"
              title="Precool"
              destinationPath={settingPaths.precool}
            >
              <SuggestionDescription>
                {precoolEnabled ? 'Enabled' : 'Disabled'}
              </SuggestionDescription>
            </SuggestionCard>
          )}
        </SettingsSuggestions>
      )}
    </DeviceSuggestionCard>
  )
}
